<template>
  <!-- 第四步：业务应用上云情况 -->
  <div class="fourthStep">
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      label-width="200px"
      class="form-wrap"
      :disabled="!ifEdit"
    >
      <div class="step-title">生产（Manufacturing）：</div>
      <el-form-item v-show="typeFlag !== '第一产业'" label="研发设计上云(个)" prop="proDesign">
        <el-input-number v-model="form.proDesign" :min="0" :max="1" />
      </el-form-item>
      <el-form-item label="生产管理上云(个)" prop="proManage">
        <el-input-number v-model="form.proManage" :min="0" :max="1" />
      </el-form-item>
      <el-form-item label="质量管理上云(个)" prop="qualityData">
        <el-input-number v-model="form.qualityData" :min="0" :max="1" />
      </el-form-item>
      <el-form-item label="生产数据上云(个)" prop="proData">
        <el-input-number v-model="form.proData" :min="0" :max="1" />
      </el-form-item>
      <el-form-item v-show="typeFlag == '第二产业'" label="能源管理上云(个)" prop="proEnergy">
        <el-input-number v-model="form.proEnergy" :min="0" :max="1" />
      </el-form-item>
      <el-form-item v-show="typeFlag == '第二产业'" label="设备监控上云(个)" prop="proDevice">
        <el-input-number v-model="form.proDevice" :min="0" :max="1" />
      </el-form-item>
      <el-form-item v-show="typeFlag !== '第三产业'" label="产品溯源上云(个)" prop="proProd">
        <el-input-number v-model="form.proProd" :min="0" :max="1" />
      </el-form-item>
      <el-form-item v-show="typeFlag !== '第三产业'" label="安全环保上云(个)" prop="safeEnv">
        <el-input-number v-model="form.safeEnv" :min="0" :max="1" />
      </el-form-item>
      <el-form-item v-show="typeFlag == '第三产业'" label="服务上云(个)" prop="proService">
        <el-input-number v-model="form.proService" :min="0" :max="1" />
      </el-form-item>
      <div class="step-title">供应链（Supply Chain）：</div>
      <el-form-item label="采购管理上云(个)" prop="srmProcure">
        <el-input-number v-model="form.srmProcure" :min="0" :max="1" />
      </el-form-item>
      <el-form-item label="仓储管理上云(个)" prop="srmStorage">
        <el-input-number v-model="form.srmStorage" :min="0" :max="1" />
      </el-form-item>
      <el-form-item label="物流管理上云(个)" prop="srmFlow">
        <el-input-number v-model="form.srmFlow" :min="0" :max="1" />
      </el-form-item>
      <div class="step-title">营销（Marketing）：</div>
      <el-form-item label="销售管理上云(个)" prop="marketSale">
        <el-input-number v-model="form.marketSale" :min="0" :max="1" />
      </el-form-item>
      <el-form-item label="门户网站上云(个)" prop="marketPortal">
        <el-input-number v-model="form.marketPortal" :min="0" :max="1" />
      </el-form-item>
      <el-form-item label="电子商务上云(个)" prop="marketShop">
        <el-input-number v-model="form.marketShop" :min="0" :max="1" />
      </el-form-item>
      <el-form-item label="客户关系管理上云(个)" prop="marketCrm">
        <el-input-number v-model="form.marketCrm" :min="0" :max="1" />
      </el-form-item>
      <el-form-item label="客服上云(个)" prop="marketCustomer">
        <el-input-number v-model="form.marketCustomer" :min="0" :max="1" />
      </el-form-item>
      <div class="step-title">业务：</div>
      <el-form-item label="其他上云(个)" prop="serviceOther">
        <el-input-number v-model="form.serviceOther" :min="0" />
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { fourthSave, fourthInfo, fourthSubmit } from "@/utils/interface";
const form = () => {
  return {
    proDesign: "", // 研发设计上云数量
    proManage: "", // 生产管理
    qualityData: "", // 质量管理
    proData: "", // 生产数据上云数量
    proEnergy: "", // 能源管理上云数量
    proDevice: "", // 设备监控上云数量
    proProd: "", // 产品溯源上云数量
    safeEnv: "", // 安全环保
    proService: "", // 服务上云数量
    srmProcure: "", // 采购管理上云数量
    srmStorage: "", // 仓储管理上云数量
    srmFlow: "", // 物流管理上云数量
    marketSale: "", // 销售管理上云数量
    marketPortal: "", // 门户网站上云数量
    marketShop: "", // 电商上云数量
    marketCrm: "", // CRM上云数量(客户关系)
    marketCustomer: "", // 客服上云数量
    serviceOther: "" // 其他上云数量
  };
};
export default {
  name: "",
  components: {},
  props: {
    typeFlag: String,
    registerId: {
      type: String
    },
    ifEdit: {
      type: Boolean,
      default: false
    } // 是否是可编辑状态，即上云申请只保存未提交,false为不可编辑，true为可编辑
  },
  data() {
    const rules = () => {
      return {
        proDesign: [{ required: true, message: "请输入数量", trigger: "blur" }],
        proManage: [{ required: true, message: "请输入数量", trigger: "blur" }],
        qualityData: [
          { required: true, message: "请输入数量", trigger: "blur" }
        ],
        proData: [{ required: true, message: "请输入数量", trigger: "blur" }],
        proEnergy: [{ required: true, message: "请输入数量", trigger: "blur" }],
        proDevice: [{ required: true, message: "请输入数量", trigger: "blur" }],
        proProd: [{ required: true, message: "请输入数量", trigger: "blur" }],
        safeEnv: [{ required: true, message: "请输入数量", trigger: "blur" }],
        proService: [
          { required: true, message: "请输入数量", trigger: "blur" }
        ],
        srmProcure: [
          { required: true, message: "请输入数量", trigger: "blur" }
        ],
        srmStorage: [
          { required: true, message: "请输入数量", trigger: "blur" }
        ],
        srmFlow: [{ required: true, message: "请输入数量", trigger: "blur" }],
        marketSale: [
          { required: true, message: "请输入数量", trigger: "blur" }
        ],
        marketPortal: [
          { required: true, message: "请输入数量", trigger: "blur" }
        ],
        marketShop: [
          { required: true, message: "请输入数量", trigger: "blur" }
        ],
        marketCrm: [{ required: true, message: "请输入数量", trigger: "blur" }],
        marketCustomer: [
          { required: true, message: "请输入数量", trigger: "blur" }
        ],
        serviceOther: [
          { required: true, message: "请输入数量", trigger: "blur" }
        ]
      };
    };
    return {
      form: form(),
      rules: rules(),
      uuid: "" // 当前条保存后的uuid
    };
  },
  watch: {
    // typeFlag(val) {
    //   if (val) {
    //     console.log("所在产业=", val);
    //   }
    // }
  },
  computed: {},
  created() {},
  mounted() {
    if (this.$route.query.uuid) {
      this.getFourthInfo();
    }
  },
  methods: {
    /* 第四步保存 */
    save(type) {
      return new Promise((resolve, reject) => {
        this.$refs.form.validate(valid => {
          if (valid) {
            let params = {
              userUuid: this.$store.state.isUsermessage.uuid,
              registerId: this.registerId,
              uuid: this.uuid,
              ...this.form
            };
            fourthSave(params).then(res => {
              if (res.success) {
                this.$message({
                  message: res.message,
                  type: "success"
                });
                this.uuid = res.data.uuid;
                if (type == "save") {
                  this.$router.push("/cloudUp");
                }
                resolve();
              } else {
                this.$message({
                  message: res.message,
                  type: "error"
                });
                reject();
              }
            });
          }
        });
      });
    },
    /* 第四步提交 */
    async submit() {
      await this.save("submit");
      await this.fourthSubmit();
      this.$router.push("/cloudUp");
    },
    /* 提交 */
    fourthSubmit() {
      return new Promise((resolve, reject) => {
        fourthSubmit(this.registerId, "COMMITTED").then(res => {
          if (res.success) {
            this.$message({
              message: res.message,
              type: "success"
            });
            resolve();
          } else {
            this.$message({
              message: res.message,
              type: "error"
            });
            reject();
          }
        });
      });
    },
    /* 第三步详情 */
    getFourthInfo() {
      fourthInfo(this.$route.query.uuid).then(res => {
        if (res.success && Object.keys(res.data).length > 0) {
          this.form = res.data;
        } else {
          this.form = form();
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
@import "../../../assets/css/common.less";
.fourthStep {
  .step-title {
    position: relative;
    font-size: 14px;
    margin: 20px 0;
    &::before {
      position: absolute;
      content: "";
      width: 4px;
      height: 4px;
      border-radius: 50%;
      .bc();
      top: 50%;
      transform: translateY(-50%);
      left: -10px;
    }
  }
  /deep/ .el-form-item {
    width: 525px;
    margin: 0 auto;
    margin-bottom: 20px;
  }
  /deep/ .el-input-number {
    width: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/enterpriseCloudUp/component/fourthStep.vue